import React from 'react';

const PendingStatus = () => {
  return (
    <div className='bg-[#EFEE01] w-[85px] h-[26px] flex justify-center items-center text-black rounded-[110px] font-[14px]'>
      Pending
    </div>
  );
};

export default PendingStatus;
